import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const useEmergencyContactsQuery = (patientUserId) => {
  return useQuery({
    queryKey: ["emergencyContactsQuery", patientUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "pcmedapi",
        path: "/profile/emergency-contacts/" + patientUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    enabled: !!patientUserId,
    select: (contacts) => {
      return contacts?.map((contact) => {
        const pPhone = contact?.phone?.split("-") ?? null;
        return {
          ...contact,
          phone: pPhone ? pPhone[1] : "",
          dialCode: pPhone ? pPhone[0] : "",
        };
      });
    },
  });
};
